import grainIcon from '@@/offer/images/grain.icon.svg';
import { PageTemplate } from '@/shared/ui/templates';
import styles from './index.module.sass';
import { pointsMap as map } from './map.model';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { mapLoaded } from '@/widgets/storage-viewer/model';
import Draggable from 'react-draggable';
import {
  $specificRouteData,
  $specificRouteDataLoadingStatus,
  fetchSpecificRouteDataFx,
  setSpecificRouteData,
} from '../../store/routes.store';
import { useParams, useSearchParams } from 'react-router-dom';
import { useStore } from 'effector-react';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import { numberToReadable } from '@/modules/common/helpers/number-to-readable.helper';
import { compareDateWithCurrentTime } from '@/modules/common/helpers/compare-date.helper';
import { $agriculture } from '@/modules/agriculture/store/agriculture.store';
import { spreadWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { OFFER_ACTION_TYPE } from '@/modules/common/constants/trade-offers.constant';
import { Link } from 'react-router-dom';
import infoSvg from '@@/mixing/images/info-icon.svg';
import { PURCHASE_PRICE_WITHOUT_VAT } from '@/shared/constants/price.constants';

export const ManagementLogisticsPage = () => {
  const [params] = useSearchParams();
  const [customBackUrl, setCustomBackUrl] = useState<string | null>(null);
  const data = useStore($specificRouteData);
  console.log(data);
  const loadingStatus = useStore($specificRouteDataLoadingStatus);
  const agricultures = useStore($agriculture);

  let animationFrame: number = 0;
  const containerDomRef = useRef<any>(null);
  const observerRef = useRef(
    new ResizeObserver(() => {
      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = 0;
      }
      animationFrame = window.requestAnimationFrame(() => {
        map.resize();
      });
    }),
  );

  useEffect(() => {
    const trade_id = params.get('trade_id');
    const warehouse_id = params.get('warehouse_id');
    const destination_id = params.get('destination_id');
    const back_url = params.get('back_url');
    if (back_url) setCustomBackUrl(back_url);
    if (trade_id && warehouse_id && destination_id) {
      fetchSpecificRouteDataFx({
        trade_id: +trade_id,
        warehouse_id: +warehouse_id,
        destination_id: +destination_id,
      });
    }
  }, [params]);

  useEffect(() => {
    ymaps.ready(() => {
      map.init('yviewer', containerDomRef.current);
      mapLoaded();
    });

    if (containerDomRef.current) {
      observerRef.current.observe(containerDomRef.current);
    }

    return () => {
      map.dispose();
      observerRef.current.disconnect();
      setSpecificRouteData(null);
    };
  }, []);

  useEffect(() => {
    data?.freight_destination && map.drawRoute(data?.freight_destination);
  }, [data?.freight_destination]);

  const parseDuration = (val: number) => {
    const hours = Math.floor(val / 60);
    const remainingMinutes = val % 60;

    const hoursPart = hours > 0 ? `${hours}ч. ` : '';
    const minutesPart = `${remainingMinutes.toLocaleString('ru', {
      maximumFractionDigits: 0,
    })}мин.`;

    return hoursPart + minutesPart;
  };

  return (
    <PageTemplate header="Логистика" customBack={customBackUrl || '/offer'}>
      <div className={styles.root}>
        {(loadingStatus.loading || loadingStatus.error || !data) && (
          <UniversalLoader error={loadingStatus.error} />
        )}
        <div className={styles.bottomArea}>
          <figure className={styles.map}>
            <Draggable bounds={'parent'}>
              <div className={styles.dataWidget}>
                <div className={styles.item}>
                  <div className={styles.midInformation}>
                    <div className={styles.leftSide}>
                      <div className={styles.grainWrap}>
                        <img src={grainIcon} className={styles.grain} />
                      </div>
                      <div className={styles.requisite}>
                        <span className={styles.bold}>
                          {
                            agricultures.find(
                              (item) => item.id === data?.agriculture_ids[0],
                            )?.name
                          }
                          , {data?.wheat_class}
                        </span>
                        <span className={styles.val}>
                          {data?.wheat_type
                            ? `${spreadWheatType(Number(data.wheat_type))?.sort} ${
                                spreadWheatType(Number(data.wheat_type))?.type
                              }`
                            : ''}
                        </span>
                      </div>
                    </div>
                    <div className={styles.rightSide}>
                      <div className={styles.requisite}>
                        <span className={styles.label}>вес</span>
                        <span className={styles.val}>
                          {numberToReadable(Number(data?.weight) || 0, 1)} т
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.item}>
                  <span className={styles.label}>место хранения</span>
                  <span className={styles.value}>
                    <b>{data?.warehouse_name}</b>
                  </span>
                  <div className={styles.action}>
                    <span className={styles.wrap}>
                      {data?.action === 'drain' ? (
                        'осушаем'
                      ) : data?.action === 'hydrate' ? (
                        'увлажняем'
                      ) : data?.action === 'mix' ? (
                        <span className={styles.tag}>миксование</span>
                      ) : (
                        ''
                      )}{' '}
                      {data?.action_place === OFFER_ACTION_TYPE.OWN_WAREHOUSE
                        ? 'на собственном складе'
                        : data?.action_place === OFFER_ACTION_TYPE.RECEIVING_POINT
                        ? 'на пункте приема зерна'
                        : ''}
                      {data?.action === 'mix' && (
                        <Link
                          className={styles.showRecipe}
                          to={
                            Array.isArray(data.bunkerreloaders_ids) &&
                            data.bunkerreloaders_ids.length > 0
                              ? `/mixing/recipe/detail/${data.mix_id}?warehouse_id=${
                                  data.warehouse_id
                                }&bunker=${JSON.stringify(
                                  data.bunkerreloaders_ids,
                                )}&viewOnly=true`
                              : `/mixing/mixer/${data.mix_id}?viewOnly=true`
                          }
                        >
                          <img src={infoSvg} />
                          показать рецепт
                        </Link>
                      )}
                    </span>
                    {/* <span className={styles.switch}>изменить</span> */}
                  </div>
                </div>
                <div className={styles.item}>
                  <span className={styles.label}>откуда</span>
                  <span className={styles.value}>
                    {data?.warehouse_point
                      ? JSON.parse(data?.warehouse_point).join(', ')
                      : ''}
                  </span>
                  <span className={styles.estimation}>
                    {numberToReadable(Number(data?.distance || 0))}км (≈
                    {parseDuration(data?.duration_min || 0)})
                  </span>
                </div>
                <div className={styles.item}>
                  <span className={styles.label}>куда</span>
                  <span className={styles.value}>{data?.destination_address}</span>
                </div>
                <div className={styles.item}>
                  <span className={styles.label}>контрагент</span>
                  <div className={styles.topInformation}>
                    <div className={styles.leftSide}>
                      <span className={styles.buyerName}>{data?.company_name}</span>
                      <span className={styles.buyerType}>
                        {data?.external ? 'внешний контрагент' : 'ваш контрагент'}
                      </span>
                    </div>
                    <div className={styles.rightSide}>
                      <div className={styles.requisite}>
                        <span className={styles.label}>срок предложения</span>
                        <span className={styles.val}>
                          {data?.expiration_date &&
                            compareDateWithCurrentTime(data?.expiration_date)}
                        </span>
                      </div>
                      <div className={styles.requisite}>
                        <span className={styles.label}>
                          {PURCHASE_PRICE_WITHOUT_VAT}
                        </span>
                        <span className={styles.val}>
                          {numberToReadable(Number(data?.price) || 0)}
                          ₽/т
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className={styles.bottomInfo}>
                    <div className={styles.totalPrice}>
                      <span className={styles.label}>
                        стоимость <br />
                        доставки
                      </span>
                      <span>
                        {numberToReadable(Number(data?.price_logistic) || 0)} ₽
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Draggable>
            <div
              className={classNames(styles.container, styles.viewContainer)}
              id="yviewer"
              ref={containerDomRef}
            />
          </figure>
        </div>
      </div>
    </PageTemplate>
  );
};
